module.exports = __webpack_public_path__ + "img/ai-content.0b4ced3a.svg";